"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useUpdate_1 = require("./useUpdate");
function useSubscriber(sub) {
    const update = useUpdate_1.useUpdate();
    react_1.useEffect(() => {
        function _update() {
            update();
        }
        sub.subscribe(_update);
        return () => {
            sub.unsubscribe(_update);
        };
    }, []);
}
exports.useSubscriber = useSubscriber;
//# sourceMappingURL=useSubscriber.js.map